import { usePostApply } from '@components/hooks/PostApplyProvider/index.client'
import Button, { buttonClassNames } from '@components/primitives/Button'
import { Icon } from '@components/primitives/Icon'
import { Text } from '@components/primitives/Text'
import { classMerge } from '@components/utilities/classMerge'
import { faPhone } from '@fortawesome/pro-regular-svg-icons/faPhone'
import { faXmark } from '@fortawesome/pro-regular-svg-icons/faXmark'
import PatientRoutes from '@lib/routes/PatientRoutes'
import { trackEvent } from '@lib/tracking'
import { TrackingEvents } from '@lib/tracking/TrackingEvents'
import { useRouter } from 'next/navigation'
import { useState } from 'react'
import { WarmTransferSkipModal } from './WarmTransferSkipModal'

export function WarmTransferIntro({
  idToken,
  onStartCall,
}: {
  idToken: string
  onStartCall: () => void
}) {
  const [skipModalOpen, setSkipModalOpen] = useState(false)
  const { advanceToNextStep } = usePostApply()
  const router = useRouter()

  return (
    <div className='flex h-full flex-col justify-between'>
      <WarmTransferSkipModal
        isOpen={skipModalOpen}
        onSkip={() => {
          trackEvent(TrackingEvents.WARM_TRANSFER_SKIPPED)
          advanceToNextStep()
          router.push(
            PatientRoutes.trialApplySurveyPostscreenerConsents(
              idToken,
              'screening-visit-availability',
            ),
          )
        }}
        setIsOpen={setSkipModalOpen}
      />
      <button
        className='absolute right-4 top-4 z-navbarContainer flex size-8 items-center justify-center rounded-full bg-neutral200 text-neutral600 hover:bg-neutral300 hover:text-neutral800'
        onClick={() => {
          trackEvent(TrackingEvents.WARM_TRANSFER_SKIP_BUTTON_CLICKED, {
            trialApplicationIdToken: idToken,
            type: 'x button',
          })
          setSkipModalOpen(true)
        }}
        type='button'
      >
        <Icon className='size-4' icon={faXmark} />
      </button>
      <div className='fixed inset-0 -z-10 bg-gradient-to-b from-white via-white to-primary50' />
      <div className='mx-auto grid max-w-4xl grid-cols-1 items-center gap-x-4 gap-y-8'>
        <Icon
          className='mx-auto size-8 rounded-full bg-primary50 p-8 text-primary500 md:size-16'
          icon={faPhone}
          size='2x'
        />
        <Text className={`text-xl font-bold md:text-3xl`} styleName={'h3'}>
          Next, call the clinic to see if you’re eligible for a screening visit
        </Text>
        <ul className='list-inside list-disc text-neutral600'>
          <li className='text-lg'>Takes 3 minutes tops.</li>
          <li className='text-lg'>{`Expect a call from +1 (817) 969-3354`}</li>
          <li className='text-lg'>Your call may be recorded.</li>
        </ul>
        <div className='mx-auto mt-4 flex w-full max-w-4xl flex-row justify-center gap-4 p-4'>
          <Button
            className={classMerge(
              buttonClassNames.legacy.fill.black,
              'pointer-events-auto w-full rounded-full md:w-1/2',
            )}
            onClick={onStartCall}
            type='submit'
          >
            Start Call
            <Icon className={'ml-2'} icon={faPhone} />
          </Button>
        </div>
      </div>
    </div>
  )
}
